import type { FC } from 'react';
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    Button,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import SecurityIcon from '@mui/icons-material/Security';
import GavelIcon from '@mui/icons-material/Gavel';
import PublicIcon from '@mui/icons-material/Public';
import ShieldIcon from '@mui/icons-material/Shield';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const features = [
    {
        icon: <DeveloperBoardIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
        title: 'Developer toolkit',
    },
    {
        icon: <SecurityIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
        title: 'KYC Solutions',
    },
    {
        icon: <GavelIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
        title: 'Compliance',
    },
    {
        icon: <PublicIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
        title: 'Global Payments',
    },
    {
        icon: <ShieldIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
        title: 'Risk Engine',
    },
    {
        icon: <AccountBalanceWalletIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
        title: 'Wallet solutions',
    },
];

export const DrivenByBestInClass: FC = () => {
    const theme = useTheme();

    const handleTalkToUs = () => {
        window.open('https://cal.com/support-team-qsszsx', '_blank');
    };

    return (
        <Box
            sx={{
                py: 15,
                backgroundColor: 'background.paper',
                width: '100vw',
                position: 'relative',
                marginLeft: 'calc(-50vw + 50%)',
                marginRight: 'calc(-50vw + 50%)',
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 700,
                        textAlign: 'center',
                        mb: 8,
                        fontSize: { xs: '2rem', md: '2.5rem' }
                    }}
                >
                    Driven by the best in class
                </Typography>

                <Grid
                    container
                    spacing={4}
                    justifyContent="center"
                >
                    {features.map((feature, index) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={index}
                        >
                            <Card
                                sx={{
                                    p: 3,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    backgroundColor: 'background.default',
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 2,
                                    transition: 'transform 0.3s, box-shadow 0.3s',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: theme.shadows[8],
                                        borderColor: 'primary.main',
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        backgroundColor: alpha(theme.palette.primary.main, 0.1),
                                        borderRadius: 2,
                                        p: 2,
                                        mb: 2
                                    }}
                                >
                                    {feature.icon}
                                </Box>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        textAlign: 'center',
                                        fontWeight: 600
                                    }}
                                >
                                    {feature.title}
                                </Typography>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                <Box sx={{ mt: 8, textAlign: 'center' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleTalkToUs}
                        sx={{
                            px: 4,
                            py: 1.5,
                            borderRadius: 2,
                        }}
                    >
                        Talk to us
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};